/** Row type for the Eligibility work queue table. */
export interface EligibilityRow {
  id: string;
  clientId: string;
  clientName: string;
  coverageId?: string;
  serviceTypeCodes?: string[];
  payer?: string;
  memberId?: string;
  clientPhone?: string;
  soharErrorReason?: string;
  assumedCopay?: string;
  soonestBookedAppointment?: string;
  daysUntilAppointment?: number;
  submissionDate?: string;
}

/** Cast an opaque tracker row (Record<string, unknown>) to a typed EligibilityRow. */
export function toEligibilityRow(row: Record<string, unknown>): EligibilityRow {
  return {
    id: String(row.id ?? ''),
    clientId: String(row.clientId ?? row.id ?? ''),
    clientName: String(row.clientName ?? ''),
    coverageId: row.coverageId != null ? String(row.coverageId) : undefined,
    serviceTypeCodes: Array.isArray(row.serviceTypeCodes)
      ? (row.serviceTypeCodes as string[])
      : undefined,
    payer: row.payer != null ? String(row.payer) : undefined,
    memberId: row.memberId != null ? String(row.memberId) : undefined,
    clientPhone: row.phone != null ? String(row.phone) : undefined,
    soharErrorReason: row.soharErrorReason != null ? String(row.soharErrorReason) : undefined,
    assumedCopay: row.assumedCopay != null ? String(row.assumedCopay) : undefined,
    soonestBookedAppointment:
      row.soonestBookedAppointment != null ? String(row.soonestBookedAppointment) : undefined,
    daysUntilAppointment:
      typeof row.daysUntilAppointment === 'number' ? row.daysUntilAppointment : undefined,
    submissionDate: row.submissionDate != null ? String(row.submissionDate) : undefined,
  };
}
